import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import Card from './AnimatedCard';
import Button from './Button';

interface PricingCardProps {
  name: string;
  description: string;
  features: string[];
  popular?: boolean;
  delay?: number;
}

const PricingCard: React.FC<PricingCardProps> = ({
  name,
  description,
  features,
  popular = false,
  delay = 0,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: delay * 0.1 }}
      viewport={{ once: true }}
      className="h-full"
    >
      <Card 
        className={`h-full flex flex-col ${
          popular ? 'border-2 border-primary-500' : 'border border-neutral-200'
        }`} 
        elevation={popular ? 'premium' : 'soft'}
      >
        {popular && (
          <div className="bg-primary-500 text-white text-center py-1 text-sm font-medium">
            Most Popular
          </div>
        )}
        <div className="p-6 md:p-8 flex-grow">
          <h3 className="text-2xl font-semibold mb-2">{name}</h3>
          <p className="text-neutral-600 mb-2">{description}</p>
          <p className="text-sm text-neutral-500 mb-6">Quoted per agent or team</p>
          <hr className="my-6 border-neutral-200" />
          <ul className="space-y-3 mb-8">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start">
                <span className="flex-shrink-0 text-primary-500 mr-2">
                  <Check size={18} />
                </span>
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="px-6 pb-8 md:px-8 flex flex-col gap-3">
          <Button variant="primary" fullWidth size="lg" to="/contact">
            Contact for Pricing
          </Button>
          <Button variant="outline" fullWidth size="lg" to="/contact">
            Request a Demo
          </Button>
        </div>
      </Card>
    </motion.div>
  );
};

export default PricingCard;